'use strict';

module.exports = {
    container: 'marker',
    min: 'cmin',
    max: 'cmax'
};
